import {ErrorHandler, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AppErrorType} from '../components/global-error-page/global-error-page.component';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private router: Router) {
  }

  async handleError(error: any): Promise<void> {

    if (error instanceof HttpErrorResponse && error.status === 500) {
      await this.router.navigate([`/error/${AppErrorType.UNKNOWN}`]);
    }
    throw error;
  }
}
